var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2GangSso01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 1.28,
    className: "st2",
    width: 0.5,
    height: 13.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.14,12.99l-0.04-0.5c2.46-0.19,4.36-2.35,4.22-4.82C8.14,5.41,6.28,3.61,4,3.49l0.03-0.5 c2.53,0.13,4.59,2.13,4.8,4.65C8.97,10.39,6.87,12.78,4.14,12.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.65,
    y: 7.75,
    className: "st2",
    width: 4.61,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "12.14,12.67 11.66,12.55 12.05,10.96 8.24,10.11 8.35,9.63 12.66,10.58  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13,5.79V6.3h-2.89c0-0.13,0.02-0.25,0.06-0.37c0.07-0.2,0.19-0.39,0.35-0.58c0.16-0.19,0.4-0.41,0.7-0.66 c0.47-0.39,0.79-0.7,0.96-0.92c0.17-0.23,0.25-0.44,0.25-0.65c0-0.21-0.08-0.39-0.23-0.54c-0.15-0.15-0.35-0.22-0.59-0.22 c-0.26,0-0.46,0.08-0.62,0.23c-0.15,0.15-0.23,0.37-0.23,0.64l-0.55-0.06c0.04-0.41,0.18-0.72,0.43-0.94 c0.25-0.22,0.58-0.32,0.99-0.32c0.42,0,0.75,0.12,0.99,0.35C12.87,2.5,13,2.79,13,3.13c0,0.17-0.04,0.35-0.11,0.52 c-0.07,0.17-0.19,0.35-0.36,0.53c-0.17,0.19-0.44,0.44-0.83,0.77c-0.32,0.27-0.53,0.45-0.62,0.55c-0.09,0.1-0.17,0.19-0.23,0.29 H13z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2GangSso01);
export default __webpack_public_path__ + "static/media/2GangSSO-01.7b0bc5ecdb7af11d08ba630839b75549.svg";
export { ForwardRef as ReactComponent };